import { defineMessages } from 'react-intl';

/**
 * Copy for the surfaces that reflect the "Bold & italics" toggle being off:
 * the instructive tooltip on the disabled Bold/Italic/Underline toolbar
 * buttons, and the toast fired when a formatting keyboard shortcut is
 * intercepted while the styles are suppressed.
 */
export const emphasisSuppressionMessages = defineMessages({
  disabledTooltip: {
    defaultMessage: 'Turn on Bold & italics in copy settings to format text',
    id: '7pVppi9QFP',
  },
  shortcutBlockedTitle: {
    defaultMessage: 'Bold & italics is off',
    id: 'qeoqsCR9GP',
  },
  shortcutBlockedDescription: {
    defaultMessage: 'Turn it on in copy settings to format text',
    id: 'GMXUSSjdjo',
  },
});
